import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DomManipulationService {
  private focusableElements: HTMLElement[] = [];
  private firstFocusableElement: HTMLElement | null = null;
  private lastFocusableElement: HTMLElement | null = null;

  focusHamburgerIcon(): void {
    const hamburgerIcon = document.querySelector(
      '#hamburger-icon'
    ) as HTMLElement;
    if (hamburgerIcon) {
      hamburgerIcon.focus();
    }
  }

  hasActiveHamburgerIcon(): boolean {
    return !!document.querySelector('.hamburger-icon.active');
  }

  updateFocusableElements(navElement: Element): void {
    const focusableSelectors = [
      'button:not([disabled])',
      'a[href]:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"]):not([disabled])'
    ].join(', ');

    this.focusableElements = Array.from(
      navElement.querySelectorAll(focusableSelectors)
    ).filter((el): el is HTMLElement => {
      return (
        (el as HTMLElement).offsetParent !== null && !(el as HTMLElement).hidden
      );
    }) as HTMLElement[];

    this.firstFocusableElement = this.focusableElements[0] || null;
    this.lastFocusableElement =
      this.focusableElements[this.focusableElements.length - 1] || null;
  }

  trapFocus(event: KeyboardEvent, navElement: Element): void {
    this.updateFocusableElements(navElement);

    if (!this.firstFocusableElement || !this.lastFocusableElement) return;

    if (event.shiftKey) {
      this.handleShiftTabFocus(event);
    } else {
      this.handleTabFocus(event);
    }
  }

  private handleShiftTabFocus(event: KeyboardEvent): void {
    if (
      document.activeElement === this.firstFocusableElement &&
      this.lastFocusableElement
    ) {
      event.preventDefault();
      this.lastFocusableElement.focus();
    }
  }

  private handleTabFocus(event: KeyboardEvent): void {
    if (
      document.activeElement === this.lastFocusableElement &&
      this.firstFocusableElement
    ) {
      event.preventDefault();
      this.firstFocusableElement.focus();
    }
  }
}
